var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJoystick = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 49.333c13.365 0 24.2-10.82 24.2-24.166C49.4 11.82 38.565 1 25.2 1 11.835 1 1 11.82 1 25.167c0 13.346 10.835 24.166 24.2 24.166Z",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.198 41.772c9.183 0 16.627-7.434 16.627-16.605 0-9.17-7.444-16.605-16.627-16.605S8.57 15.997 8.57 25.168c0 9.17 7.445 16.605 16.628 16.605Z",
    stroke: "#fff"
  })));
};
export { SvgJoystick as ReactComponent };